var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.data),function(value,key){return _c('v-col',{key:key,attrs:{"cols":"12","sm":"6","md":"6","lg":"6","xl":"6"}},_vm._l((value),function(block,i){return _c('StreamfieldBlock',{key:i,attrs:{"block":block}})}),1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }